import Axios from '../../utils/tms-axios/tms-axios';
import TmsStringUtils from '../../utils/tms-string-utils/tms-string-utils';

export const nakshatramService = {
  getAll: async (page = 1, limit = 10) => {
    const resp = await Axios.get(`/v1/nakshatram/all`, {
      params: {
        page: page,
        limit: limit,
      },
    });

    return resp.data;
  },

  getById: async (nakshatramId) => {
    const resp = await Axios.get(`/v1/nakshatram/by-id/${nakshatramId}`);

    return resp.data;
  },

  createNakshatram: async (name, description) => {
    const resp = await Axios.post(`/v1/nakshatram/create`, {
      name: name,
      key: TmsStringUtils.normalizeString(name),
      description: description,
    });

    return resp.data;
  },

  updateNakshatram: async (nakshatramId, name, description) => {
    const resp = await Axios.put(`/v1/nakshatram/update/${nakshatramId}`, {
      name: name,
      key: TmsStringUtils.normalizeString(name),
      description: description,
    });

    return resp.data;
  },

  deleteNakshatram: async (nakshatramId) => {
    const resp = await Axios.delete(`/v1/nakshatram/delete/${nakshatramId}`);

    return resp.data;
  },
};
